<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/IH802Z/tc-custom/9781468302363.jpg?1734319690099" alt="This image is the cover for the book With Nails"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">With Nails
      </h1>
      <p class="bookDescription body article font2">
        <b>The star of the cult classic <i>Withnail and I</i> offers “a refreshing combination of comedy, confession, and coruscation” in this memoir of the movie business (<i>Kirkus Reviews</i>).</b><br/>  <br/> Richard E. Grant’s acting career has included memorable roles in some of Hollywood’s most critically acclaimed films, including Robert Altman’s <i>Gosford Park</i> and Francis Ford Coppola’s <i>Dracula</i>. But he attributes his success to his first film role, starring as a flamboyantly pathetic Shakespearean in the underground hit <i>Withnail and I</i>. As Grant explains, “I had no notion that, almost without exception, <i>every</i> film offered since would be the result of playing an alcoholic out-of-work actor.”<br/>  <br/> In <i>With Nails</i>, Grant shares his long, maddening, and immensely rewarding journey through the world of film. From the hell of making <i>Hudson Hawk</i> to befriending Steve Martin on the set of <i>L.A. Story</i>; and from eating spaghetti with the Coppolas, to window-shopping with Sharon Stone, and working with and learning from the best actors and directors in the business, Grant’s unvarnished memoir “is a biting and wonderfully funny look at the movie business by an actor who is as clear-eyed and observant about himself as he is about the craziness surrounding him” (<i>Publishers Weekly</i>, starred review).
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Richard E. Grant
      </h2>
      
      <p class="authorDescription body article">Richard E. Grant was born and brought up in Mbabane, Swaziland. He went to London in 1982, waitered, repped, toured, and fringed until getting a role in a television satire about advertising, <I>Honest, Decent and True</I>. This led to being cast in Bruce Robinson&#39;s <I>Withnail and I</I> in 1986. His films include <I>Hidden City</I>, <I>Warlock</I>, <I>How to Get Ahead in Advertising</I>, <I>Mountains of the Moon</I>, <I>Killing Dad</I>, <I>L.A. Story</I>, <I>Hudson Hawk</I>, <I>The Player</I>, <I>Dracula</I>, <I>The Age of Innocence</I>, <I>Pr&ecirc;t-&agrave;-Porter</I>, <I>Jack and Sarah</I>, <I>The Portrait of a Lady</I>, <I>Twelfth Night</I>, <I>The Serpent&#39;s Kiss</I>, <I>Spice World</I>, <I>The Corpse Bride</I>, and <I>Penelope</I>. He has written articles for <I>Vanity Fair</I> and <I>Premiere</I>. Richard E. Grant lives in London with his family.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The Overlook Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?711645da